<!-- eslint-disable vue/no-v-html -->
<template>
  <ActivityFrame
    v-if="!(!show && status === 'ongoing')"
    :type="true"
  >
    <template v-slot:content>
      <template v-if="status === 'ongoing'">
        <ActivityInfo />
        <!-- 形狀：pill/空值/squared -->
        <b-button
          pill
          :style="`background: rgba(${
            FrontPageData.introductionButtonColor
          }, 1.0); border-color: rgba(${
            FrontPageData.introductionButtonColor
          }, 1.0); color: rgba(${
            FrontPageData.introductionButtonColor === '255,255,255'
              ? '45,167,193'
              : '255,255,255'
          },1.0) `"
          @click="participateActivity"
        >
          {{ $t("activity.i-know") }}
        </b-button>
      </template>
      <template v-else>
        <hr>
        <div
          class="text-left w-100 text-break-all"
          style="min-height: 20vh"
        >
          <p
            v-if="status === 'upcoming'"
            v-html="FrontPageData.beforeWording"
          />
          <p
            v-else-if="status === 'ended'"
            v-html="FrontPageData.afterWording"
          />
        </div>
      </template>
    </template>
  </ActivityFrame>
</template>

<script>
import ActivityFrame from '@/components/activity/ActivityFrame.vue';
import ActivityInfo from '@/components/activity/ActivityInfo.vue';
import actService from '@/services/actService';
import ssoService from '@/services/ssoService';
import store from '@/store/index';
import i18n from '@/locales/i18n';

export default {
  components: {
    ActivityFrame,
    ActivityInfo,
  },
  data() {
    return {
      // 活動資料
      activity: { scratchOffInfo: {}, slotInfo: {}, rouletteInfo: {} },
      FrontPageData: {
        introductionButtonColor: '',
        beforeWording: '',
        afterWording: '',
        isintroduction: '',
      },
      // 活動進行狀態 ongoing:進行中, upcoming:未開始, ended:已結束
      status: 'ongoing',
      show: false,
    };
  },
  beforeRouteEnter(to, from, next) { // 將參數記入store
    if (!to.params.companyId || !to.params.memberSourceId || !to.params.activityId || !to.params.eventId) {
      next({
        name: 'Error',
        params: { content: i18n.t('error.url-invalid') },
      });
    } else {
      store.commit('set', { name: 'companyId', value: to.params.companyId });
      store.commit('set', {
        name: 'memberSourceId',
        value: to.params.memberSourceId,
      });
      store.commit('set', { name: 'activityId', value: to.params.activityId });

      // 前往活動錯誤頁函數
      const goToErrorPage = () => {
        next({
          name: 'Error',
          params: { content: i18n.t('error.activity-not-found') },
        });
      };

      // 取得活動資料
      store.dispatch('getActivity').then(
      // API呼叫成功
        (activity) => {
        // ErrorPage 進入的情境
        // 1.活動不存在
        // 2.刪除 or 草稿 activity.status !== 'submitted'
          if (!activity || activity.status !== 'submitted') {
            goToErrorPage();
          } else {
          // 2021.05.10 調整流程，如果如果已抽過獎就到結束頁
          // 2021.05.26 index.js的getActivity增加 activeType: 1 (不管active true跟false都會抓)
          // 所以現在 進行中 跟 下架 都會進來
          // 進行中 activity.status === 'submitted' & isActive 為 true
          // 下架 activity.status === 'submitted' & isActive 為 false

            // 進行中
            // 1.已抽過獎 => 進入結果 (ActivityEndPage)
            // 2.未抽過獎 => 抽獎 (ActivityEventPage)

            // 下架
            // 1.已抽過獎 => 進入結果 (ActivityEndPage)
            // 2.未抽過獎 => 活動結束
            // 2021/11/24 如果getActivityResult 失敗就導去錯誤頁
            store.dispatch('getActivityResult', activity.no).then((results) => {
              if (results === null) {
                goToErrorPage();
              } else if (results.length > 0 && results[0].complete && store.state.memberId && store.state.accessToken) { // 已登入，而且抽過獎
                next({ name: activity.isShareFullURL ? 'EndPage' : 'EndPageFake', params: to.params });
              } else if (store.state.memberId && store.state.accessToken) { // 已登入，未抽過獎
                store.commit('set', { name: 'isComplete', value: results.length > 0 });
                if (results.length > 0) {
                  store.commit('set', {
                    name: 'activityResultId',
                    value: results[0].id,
                  });
                }
                next();
              } else { // 未登入
                const href = window.location.href
                  .split('?')
                  .shift()
                  .split('#')
                  .shift()
                  .replace(/\/$/, '');
                const redirectUrl = encodeURIComponent(`${href}/SSO`);
                const ssoUrl = JSON.parse(process.env.VUE_APP_USE_ENV)
                  ? '${VUE_APP_VUE_SSO_URL}'
                  : process.env.VUE_APP_VUE_SSO_URL;
                const queryString = new URLSearchParams({
                  companyid: store.state.companyId,
                  membersourceid: store.state.memberSourceId,
                }).toString();
                const ssoLoginUrl = `${ssoUrl}login?${queryString}&redirect_url=${redirectUrl}`;

                if (ssoLoginUrl) {
                  // 以 Line 瀏覽器、Liff 開啟 (目前一定進入此路線)
                  window.location.href = `${ssoLoginUrl}&linebind=1`;
                }
              }
            });
          }
        },
        // API呼叫失敗
        () => {
          goToErrorPage();
        },
      );
    }
  },
  created() {
    // 2021.05.10 調整流程
    // === 在beforeRouteEnter檢查
    // 如果已抽過獎
    // 1.store有memberid(已經從SSO登入後過來)
    // 2.getActivityResult有資料
    // 符合以上兩項，就導向 EndPage
    // === created()
    // 1.檢查是否有memberid
    //   1.沒有 => 登入SSO以取得memberID => 再從SSO導回ActivityFrontPage
    //   2.有 => 抽獎，但不用再登入SSO
    const vm = this;
    const { memberId, accessToken } = vm.$store.state;
    // 取得活動資料
    vm.$store.dispatch('getActivity').then((activity) => {
      vm.activity = activity;

      switch (activity.categoryID) {
        case 'Scratchoff':
          vm.FrontPageData.introductionButtonColor = activity.scratchOffInfo.introductionButtonColor;
          vm.FrontPageData.beforeWording = activity.scratchOffInfo.beforeWording;
          vm.FrontPageData.afterWording = activity.scratchOffInfo.afterWording;
          vm.FrontPageData.isintroduction = activity.scratchOffInfo.isintroduction;
          break;
        case 'Slot':
          vm.FrontPageData.introductionButtonColor = activity.slotInfo.introductionButtonColor;
          vm.FrontPageData.beforeWording = activity.slotInfo.beforeWording;
          vm.FrontPageData.afterWording = activity.slotInfo.afterWording;
          vm.FrontPageData.isintroduction = activity.slotInfo.isintroduction;
          break;
        case 'Roulette':
          vm.FrontPageData.introductionButtonColor = activity.rouletteInfo.introductionButtonColor;
          vm.FrontPageData.beforeWording = activity.rouletteInfo.beforeWording;
          vm.FrontPageData.afterWording = activity.rouletteInfo.afterWording;
          vm.FrontPageData.isintroduction = activity.rouletteInfo.isintroduction;
          break;
        default:
          break;
      }

      // 2021.05.10 調整畫面
      // 判斷此人是否已玩過遊戲(中過獎)，中過獎不論活動生效日期一律顯示活動頁面(中獎畫面
      // 2021.05.26 改成下架活動也會抓到，所以要多判斷
      vm.checkIsActivityOngoing();

      // 先登入SSO得到memberId才能進行判定
      if (memberId === undefined || memberId === '' || accessToken === undefined || accessToken === '') {
        vm.SingInSSO();
      } else if (vm.FrontPageData.isintroduction === 'false') {
        vm.participateActivity();
      } else {
        vm.show = true;
      }
    });
  },
  methods: {
    // 判斷活動是否未開始或是已結束 2021.05.10調整判斷邏輯
    checkIsActivityOngoing() {
      const vm = this;
      const now = Date.now();

      // 活動未開始
      if (vm.activity.startTime > now) {
        vm.status = 'upcoming';
        return false;
      }

      // 活動已結束
      if (vm.activity.endTime < now) {
        vm.status = 'ended';
        return false;
      }

      // 2021.05.26 改成下架活動也會抓到，所以要多判斷
      // 活動已下架
      if (vm.activity.isActive === false
          || vm.activity.isActive === 0) {
        vm.status = 'ended';
        return false;
      }

      // 獎品已耗盡
      const remainingItemQty = vm.activity.item
        // 抽取機率大於0
        .filter((item) => item.probability > 0)
        .reduce((sum, current) => sum + current.lotteryCnt, 0);
      if (remainingItemQty === 0) {
        vm.status = 'ended';
        return false;
      }

      // 活動進行中
      vm.status = 'ongoing';
      return true;
    },
    SingInSSO() {
      const vm = this;

      if (vm.activity.isLogin) {
        this.goToSSO();
      }
      // 目前不會走到此流程，故註解
      // else {
      //   vm.goToLineLogin();
      // }
    },
    // 進入活動流程
    participateActivity() {
      const vm = this;
      const { memberId } = vm.$store.state;
      // 2021.05.10 調整流程
      // 先判斷此人是否已玩過遊戲(中過獎)，中過獎不論活動生效日期一律顯示活動頁面(中獎畫面)
      // 所以先不檢查活動期間，改成一律先取得memberid

      // 若活動並非進行中，不做動作
      const isOngoing = vm.checkIsActivityOngoing();
      if (!isOngoing) return;

      if (!store.state.isComplete) {
        // 新增活動結果並取得活動結果ID
        const { companyId, memberSourceId } = vm.$store.state;
        const body = {
          companyId, memberSourceId, no: vm.activity.no, memberID: memberId,
        };
        // 組成digest
        ssoService
          .getDigest(companyId, memberSourceId, body)
          .toPromise()
        // 新增活動結果
          .then((res) => {
            const header = { digest: res.response.data[0].digest };
            return actService.createActivityResult(body, header).toPromise();
          })
        // 取得活動結果ID
          .then((res) => {
            vm.$store.commit('set', {
              name: 'activityResultId',
              value: res.response.data[0].id,
            });
            // 導頁到 ActivityEventPage
            vm.goToEventPage();
          });
      } else {
        // 導頁到 ActivityEventPage
        vm.goToEventPage();
      }
    },
    goToEventPage() {
      const vm = this;
      const { activityResultId } = vm.$store.state;
      const routerParams = this.$route.params;
      const eventPageFakeParams = [];
      eventPageFakeParams.eventId = routerParams.eventId;
      eventPageFakeParams.companyId = routerParams.companyId;
      eventPageFakeParams.memberSourceId = routerParams.memberSourceId;
      eventPageFakeParams.activityId = routerParams.activityId;
      eventPageFakeParams.activityResultId = activityResultId;
      vm.$router.push({ name: 'EventPageFake', params: eventPageFakeParams });
    },
    // 前往SSO
    goToSSO() {
      const vm = this;
      const { companyId, memberSourceId } = vm.$store.state;
      const href = window.location.href
        .split('?')
        .shift()
        .split('#')
        .shift()
        .replace(/\/$/, '');
      const redirectUrl = encodeURIComponent(`${href}/SSO`);
      const ssoUrl = JSON.parse(process.env.VUE_APP_USE_ENV)
        ? '${VUE_APP_VUE_SSO_URL}'
        : process.env.VUE_APP_VUE_SSO_URL;
      const queryString = new URLSearchParams({
        companyid: companyId,
        membersourceid: memberSourceId,
      }).toString();
      const ssoLoginUrl = `${ssoUrl}login?${queryString}&redirect_url=${redirectUrl}`;

      if (vm.validateUrl(ssoLoginUrl)) {
        // 以 Line 瀏覽器、Liff 開啟 (目前一定進入此路線)
        // eslint-disable-next-line no-constant-condition
        // 跳轉至 Line 綁定頁
        window.location.href = `${ssoLoginUrl}&linebind=1`;
      }
    },
    // 前往Line Login (pending，未測試)
    goToLineLogin() {
      const vm = this;
      const { activityResultId } = vm.$store.state;
      const href = window.location.href
        .split('?')
        .shift()
        .split('#')
        .shift()
        .replace(/\/$/, '');
      const redirectUrl = encodeURIComponent(
        `${href}/${activityResultId}/LineLogin`,
      );
      const comUrl = JSON.parse(process.env.VUE_APP_USE_ENV)
        ? '${VUE_APP_API_COM_URL}'
        : process.env.VUE_APP_API_COM_URL;
      const companyId = JSON.parse(process.env.VUE_APP_LINE_LOGIN_COMPANY_ID)
        ? '${VUE_APP_LINE_LOGIN_COMPANY_ID}'
        : process.env.VUE_APP_LINE_LOGIN_COMPANY_ID;
      const lineLoginUrl = `${comUrl}api/v1/linecode?DirectUrl=${redirectUrl}&CompanyId=${companyId}`;

      if (vm.validateUrl(lineLoginUrl)) {
        // 跳轉至 Line Login
        window.location.href = lineLoginUrl;
      }
    },
    // 檢查URL是否合法
    validateUrl(url) {
      if (url) return true;
      return false;
    },
  },
};
</script>
